module.exports = __webpack_public_path__ + "static/media/fvlite_background.7ca6b210.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fvlite_background.png
// module id = 2236
// module chunks = 0